const STORAGE_KEY = 'screenshot_hint_dismissed_at';

export function markScreenshotPopoverDismissed() {
  localStorage.setItem(STORAGE_KEY, Date.now().toString());
}

export function shouldShowScreenshotPopover(): boolean {
  const lastDismiss = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);
  const oneWeek = 7 * 24 * 60 * 60 * 1000;
  return Date.now() - lastDismiss > oneWeek;
}
